export const PERMISSION = {
  ADD: 'REQUEST_PURCHASE_ADD',
  EDIT: 'REQUEST_PURCHASE_EDIT',
  VIEW: 'REQUEST_PURCHASE_VIEW',
  DEL: 'REQUEST_PURCHASE_DEL',
  PRINT: 'REQUEST_PURCHASE_PRINT',
};

export const STATUS_ORDER = {
  NOTORDER: 0,
  ORDERED: 1,
  ALL: 2,
};

export const STATUS_ORDER_OPTIONS = [
  {
    label: 'Tất cả',
    value: STATUS_ORDER.ALL,
  },
  {
    label: 'Đã đặt hàng',
    value: STATUS_ORDER.ORDERED,
  },
  {
    label: 'Chưa đặt hàng',
    value: STATUS_ORDER.NOTORDER,
  },
];

export const STATUS_REVIEW = {
  NOTREVIEW: 0, // không duyệt
  REVIEWED: 1, // đã duyệt
  REVIEWING: 2, // chưa duyệt
  ALL: 3,
};

export const STATUS_REVIEW_OPTIONS = [
  {
    label: 'Tất cả',
    value: STATUS_REVIEW.ALL,
  },
  {
    label: 'Đã duyệt',
    value: STATUS_REVIEW.REVIEWED,
  },
  {
    label: 'Chưa duyệt',
    value: STATUS_REVIEW.REVIEWING,
  },
  {
    label: 'Không duyệt',
    value: STATUS_REVIEW.NOTREVIEW,
  },
];


export const MOCK_INITIAL_VALUES = {
  "company_id": 1,
  "business_request_id": 3,
  "business_receive_id": 1,
  "department_request_id": 1,
  "store_receive_id": 1,
  "supplier_id": 1012
};
